import { createContext, useContext } from 'react';
import { TelemetryUtils } from './telemetryClient.js';
import { RemoteConfigReceived } from './web.schema.js';

class BaseTrackingAdapter {
    telemetryClient;
    telemetryUtils;
    constructor(telemetryClient) {
        this.telemetryClient = telemetryClient;
        this.telemetryUtils = new TelemetryUtils(this.telemetryClient);
        this.telemetryUtils.trackMachineTranslation();
        this.telemetryUtils.trackSession();
    }
    //eslint-disable-next-line
    createTelemetryTrackingFunction(event) {
        //eslint-disable-next-line
        //@ts-ignore TODO: We need to update storybook to handle this
        return (...args) => this.telemetryClient.trackTelemetryEvent(new event(...args));
    }
    getTrackingID() {
        return this.telemetryClient.getTrackingID();
    }
    setExperiments(experiments) {
        this.telemetryClient.setExperiments(experiments);
    }
    setUserData({ userID }) {
        this.telemetryClient.setUserId(userID);
    }
    reset() {
        this.setUserData({ userID: null });
        this.telemetryClient.resetTrackingID();
    }
    trackRemoteConfigReceived = this.createTelemetryTrackingFunction(RemoteConfigReceived);
}
const TrackingContext = createContext(undefined);
const useBaseTracker = () => {
    const context = useContext(TrackingContext);
    if (!context) {
        throw new Error("useTracker must be used within a TrackingContextProvider");
    }
    return context;
};

export { BaseTrackingAdapter, TrackingContext, useBaseTracker };
//# sourceMappingURL=BaseTrackingAdapter.js.map
